import { render } from "./EditWatchlistModal.vue?vue&type=template&id=3fb6af79&scoped=true"
import script from "./EditWatchlistModal.vue?vue&type=script&lang=js"
export * from "./EditWatchlistModal.vue?vue&type=script&lang=js"

import "./EditWatchlistModal.vue?vue&type=style&index=0&id=3fb6af79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb6af79"]])

export default __exports__